export default (state = '', action) => {
  let { type, payload } = action
  switch (type) {
  case 'CHANGES_LAST_CALLED_SET':
    return payload
  case 'LOGOUT':
    return ''
  default:
    return state
  }
}
